import { render, staticRenderFns } from "./DisplayDataTable.vue?vue&type=template&id=8c19e6d6&"
import script from "./DisplayDataTable.vue?vue&type=script&lang=js&"
export * from "./DisplayDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports